// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
}
.define-leave-main {
  /* border: 1px solid black; */
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  height: 479px;
  overflow: scroll;
}
.outer-container-addLeave {
  width: 100%;
  /* height: 80vh; */
  /* border: 1px solid black; */
}

.add_leave_header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 0.5rem 0rem;
}

.header-left-buttons {
  display: flex;
  gap: 10px;
}
.header-right-title {
  font-weight: 600;
  font-size: 16px;
}

.heading-add button:hover {
  cursor: pointer;
}

.add-leave-table {
  padding: 5px;
  /* border: 1px solid black; */
  width: 100%;
  /* height: 100px; */
}
.delete-icon {
  color: #84c7ae;
  height: 18px;
  width: auto;
}
.inputs-after-check-main {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr;
  padding: 4px;
  height: 26px;
  font-size: 0.7rem;
  text-align: center;
  /* background-color: #d8f3d8; */
  width: 100%;
  /* margin: 0px; */
  /* font-weight: 600; */
  /* border-radius: 4px; */
}
.inputs-after-check-main input {
  width: 80%;
  margin: 3px;
  padding: 2px;
  border: 1px solid #8c8c8c;
  border-radius: 4px;
  font-family: "Karla", sans-serif;
}
.input-tables {
  width: 100%;
}
.input-tables input[type="number"]::placeholder {
  font-size: 10px;
  color: #838383;
}
.input-tables p {
  margin-top: 8px;
  font-size: 0.8rem;
}
.bottom-line {
  width: 99%;
  border-bottom: 1px solid rgb(200 200 200);
  margin-top: 5px;
}
.new-joinee-table-section {
  display: flex;
  flex-direction: column;
  /* border: 1px solid black; */
  /* position: relative; */
  box-sizing: border-box;
  /* position: absolute; */
  border: 1px solid #767272;
  width: 45%;
  border-radius: 4px;
  margin-top: 8px;
}
.button-add-row {
  display: flex;
  gap: 25px;
  /* margin-top: 10px; */
  margin: 10px;
}
.button-add-row button {
  background-color: rgb(132, 199, 174);
  color: white;
  height: 26px;
  padding: 3px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  font-size: 9px;
  width: 65px;
}
/* forms section css */

.form-section-add-leave {
  /* border: 1px solid black; */
  height: auto;
  width: 100%;
  box-sizing: border-box;
}
.heading-add button {
  all: unset;
  color: white;
  background-color: #75b39d;
  width: 80px;
  height: 28px;
  text-align: center;
  border-radius: 4px;
}
.container-name-section {
  display: flex;
  flex-direction: row;
  gap: 7%;
}
.name-section input {
  all: unset;
  border: 1px solid #b6b6b6;
  border-radius: 4px;
  padding: 5px;
  margin-top: 2px;
  font-size: 0.8rem;
  padding: 8px;
  margin-top: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  /* width: 40%; */
}
.name-section input::placeholder {
  font-size: 10px;
  opacity: 50%;
  padding-left: 0px;
}
.name-section {
  margin: 7px;
}
.name-section label {
  all: unset;
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;
  color: rgb(33, 33, 33);
}

.heading-add {
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.lable-add-section {
  border-bottom: 1px solid gray;
  margin: 5px;
  display: flex;
  /* border: 1px solid black; */
  /* width: 22%; */
  /* justify-content: space-around; */
  gap: 2px;
}
.lable-add-section label {
  /* all: unset; */
  border-right: 1px dotted black;
  padding: 6px;
  font-size: 13px;
  width: 90px;
  text-align: center;
  /* color: rgb(33, 33, 33); */
}
.lable-add-section label:hover {
  cursor: pointer;
}

.criteria-input-section {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.criteria-input-section label {
  all: unset;
  font-size: 0.8rem;
  margin-bottom: -5px;
  color: rgb(33, 33, 33);
  margin-bottom: 2px;
}
.criteria-input-section select {
  border: 1px solid #b6b6b6;
  /* width: 14%; */
  border-radius: 3px;
  padding: 6px;
  margin-top: 6px;
  color: rgb(59, 59, 59);
  font-size: 12px;
}
.leave-credit-on {
  display: flex;
  justify-content: start;
}
.credit-button-section {
  margin-left: 1%;
  height: auto;
  /* border: 1px solid black; */
}
.credit-button-container {
  display: flex;
  gap: 26%;
  /* border: 1px solid black; */
  margin-top: 10px;
}
.credit select {
  font-size: 12px;
  border: 1px solid #b6b6b6;
  width: 14%;
  padding: 3px;
  border-radius: 3px;
  margin-left: -1px;
  color: #585858;
}
.credit {
  margin-left: -1px;
}
.container-new-joinee {
  display: flex;
  gap: 5px;
}
.container-new-joinee label {
  font-size: 0.8rem;
  color: rgb(33, 33, 33);
  margin-bottom: 0px;
}
#new-joinee {
  width: 13px;
}
.leave-credit-on {
  /* display: flex; */
  gap: 10px;
  margin-top: 12px;
  /* border: 1px solid black; */
}
.leave-credit-input {
  width: 12px;
}
.leave-credit-on label {
  font-size: 13px;
  margin-bottom: 0px;
  color: rgb(33, 33, 33);
  width: 100%;
}

.main-container-leve-no-days {
  display: flex;
  gap: 16.8%;
  margin-bottom: 15px;
  margin-top: 18px;
}

.no-of-days input[type="text"] {
  all: unset;
  border: 1px solid #b6b6b6;
  width: 49%;
  border-radius: 4px;
  padding: 4px;
}
.no-of-days input[type="text"]::placeholder {
  font-size: 11px;
  color: #a2a2a2;
}
.no-of-days label {
  font-size: 0.8rem;
  color: rgb(33, 33, 33);
  margin-bottom: 5px;
}
/* table leveas */

.table-wrapper {
  border-radius: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #d9e3d9;
  background-color: white;
  height: 380px;
}
.table-wrapper::-webkit-scrollbar {
  display: none;
}
.table-row,
.table-header-leaves {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr 2fr 2fr 1fr;
  padding: 7px;
  height: 31px;
  font-size: 0.7rem;
  text-align: center;
}

.table-header-leaves {
  background-color: #d8f3d8;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1;
}

.table-row button {
  font-size: 0.7rem;
}
.input-container-form {
  box-sizing: border-box;
  /* border: 1px solid black; */
}
.leaves-action-buttons {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 5px;
}

/* new joinee table */
.table-header-sections {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr;
  padding: 4px;
  height: 20px;
  font-size: 0.7rem;
  text-align: center;
  background-color: #d8f3d8;
  width: 100%;
  /* margin: 0px; */
  font-weight: 600;
  border-radius: 4px;
}

/* Encshment css */
.encashment-button-section {
  /* border: 1px solid black; */
  height: auto;
  width: 100%;
  display: flex;
  gap: 10%;
}
.checked-section {
  /* border: 1px solid black; */

  height: auto;
  width: 15%;
}
.encash-input-section {
  /* border: 1px solid black; */

  height: auto;

  width: 30%;
}

/* Applicability */

.criteria-table-sections {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 4px;
  height: 20px;
  font-size: 0.7rem;
  text-align: center;
  background-color: #d8f3d8;
  width: 100%;
  margin-top: 5px;
  font-weight: 600;
}

.criteria-row {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 18%;
  font-size: 0.7rem;
  /* margin-top: 6px; */
  border-bottom: 1px solid rgb(170, 170, 170);
  margin: 5px 0px 9px;
}

.view-icon {
  color: #84c7ae;
  height: 18px;
  width: 15px;
}
.back-icon {
  /* margin-top: 10px; */
  height: 12px;
}

.criteria-input-section option {
  font-size: 12px;
  color: rgb(66, 66, 66);
}

.container-table {
  border: 1px solid rgb(119, 119, 119);
  margin-top: 8px;
  border-radius: 4px;
  width: 45%;
}

.activeclass {
  color: white;
  background-color: rgb(132, 199, 174);
}
.non-active {
  color: black;
}
.save-button-div {
  width: 20%;
  height: 40px;

  margin: 20px 0px 0px 10px;
}

.leave-view-edit-delete {
  margin-right: 5px;
  margin-left: 5px;
}

.leave-credit-on {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  margin-top: 50px;
}

.tooltip-label {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 125%; /* adjust as needed */
  left: 0;
  width: 240px;
  background-color: #444;
  color: #fff;
  padding: 8px;
  border-radius: 6px;
  z-index: 10;
  transition: opacity 0.3s;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 10px;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #444 transparent transparent transparent;
}

.tooltip-label:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.attendance-percentage-section input {
  width: 63%;
}

/* Default: Mobile-first styles (below 768px) */
/* Keep your base styles here */

/* Tablets: 768px to 1024px */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .define-leave-main,
  .form-section-add-leave,
  .input-container-form {
    width: 100%;
    height: auto;
    box-sizing: border-box;
  }

  .heading-add {
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .heading-add button {
    all: unset;
    color: white;
    background-color: #75b39d;
    width: 80px;
    height: 24px;
    text-align: center;
    border-radius: 4px;
  }

  .container-name-section {
    display: flex;
    flex-direction: row;
    gap: 7%;
  }

  .name-section {
    margin: 7px;
  }

  .name-section label {
    all: unset;
    display: flex;
    flex-direction: column;
    font-size: 0.8rem;
    color: #212121;
  }

  .name-section input {
    all: unset;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    margin-top: 4px;
    font-size: 0.8rem;
  }

  .lable-add-section {
    display: flex;
    border-bottom: 1px solid gray;
    margin: 5px;
    gap: 2px;
  }

  .lable-add-section label {
    border-right: 1px dotted black;
    padding: 6px;
    font-size: 13px;
    width: 90px;
    text-align: center;
  }

  .credit-button-section {
    margin-left: 1%;
  }

  .credit-button-container {
    display: flex;
    gap: 26%;
    margin-top: 10px;
  }

  .criteria-input-section {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }

  .main-container-leve-no-days {
    display: flex;
    gap: 16.8%;
    margin: 18px 0 15px;
  }

  .leave-credit-on {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 30px;
  }

  .no-of-days {
    margin-left: -4px;
  }
  .encashment-button-section {
    /* border: 1px solid black; */
    height: auto;
    width: 100%;
    display: flex;
    gap: 10%;
  }
  .checked-section {
    /* border: 1px solid black; */
    height: auto;
    width: 23%;
  }
}

/* 768px exact fix (e.g., some edge cases on tablets) */
@media screen and (width: 768px) {
  .no-of-days {
    margin-left: -32px;
  }
}

/* Small Desktops: 1025px to 1439px */
@media screen and (min-width: 1025px) and (max-width: 1440px) {
  /* You can inherit most styles from tablet if they work fine */
  /* Only override differences here */
  .leave-credit-on {
    margin-top: 15px;
  }
  .credit-button-container {
    gap: 30%;
  }

  .main-container-leve-no-days {
    gap: 18%;
  }

  .no-of-days {
    margin-left: 35px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/DefineLeave/defineLeaves.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,WAAW;AACb;AACA,sBAAsB;;AAEtB;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,mCAAmC;EACnC,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;AACA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;EACb,kDAAkD;EAClD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;AACV;AACA;EACE,6BAA6B;;EAE7B,YAAY;EACZ,UAAU;AACZ;AACA;EACE,6BAA6B;;EAE7B,YAAY;;EAEZ,UAAU;AACZ;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY,EAAE,qBAAqB;EACnC,OAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA,+CAA+C;AAC/C,+BAA+B;;AAE/B,6BAA6B;AAC7B;EACE;;;IAGE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,OAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,aAAa;IACb,QAAQ;EACV;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,qCAAqC;AACrC;EACE,8DAA8D;EAC9D,mCAAmC;EACnC;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n}\n.define-leave-main {\n  /* border: 1px solid black; */\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  height: 479px;\n  overflow: scroll;\n}\n.outer-container-addLeave {\n  width: 100%;\n  /* height: 80vh; */\n  /* border: 1px solid black; */\n}\n\n.add_leave_header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  margin: 0.5rem 0rem;\n}\n\n.header-left-buttons {\n  display: flex;\n  gap: 10px;\n}\n.header-right-title {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.heading-add button:hover {\n  cursor: pointer;\n}\n\n.add-leave-table {\n  padding: 5px;\n  /* border: 1px solid black; */\n  width: 100%;\n  /* height: 100px; */\n}\n.delete-icon {\n  color: #84c7ae;\n  height: 18px;\n  width: auto;\n}\n.inputs-after-check-main {\n  display: grid;\n  grid-template-columns: 2fr 2fr 2fr 2fr;\n  padding: 4px;\n  height: 26px;\n  font-size: 0.7rem;\n  text-align: center;\n  /* background-color: #d8f3d8; */\n  width: 100%;\n  /* margin: 0px; */\n  /* font-weight: 600; */\n  /* border-radius: 4px; */\n}\n.inputs-after-check-main input {\n  width: 80%;\n  margin: 3px;\n  padding: 2px;\n  border: 1px solid #8c8c8c;\n  border-radius: 4px;\n  font-family: \"Karla\", sans-serif;\n}\n.input-tables {\n  width: 100%;\n}\n.input-tables input[type=\"number\"]::placeholder {\n  font-size: 10px;\n  color: #838383;\n}\n.input-tables p {\n  margin-top: 8px;\n  font-size: 0.8rem;\n}\n.bottom-line {\n  width: 99%;\n  border-bottom: 1px solid rgb(200 200 200);\n  margin-top: 5px;\n}\n.new-joinee-table-section {\n  display: flex;\n  flex-direction: column;\n  /* border: 1px solid black; */\n  /* position: relative; */\n  box-sizing: border-box;\n  /* position: absolute; */\n  border: 1px solid #767272;\n  width: 45%;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n.button-add-row {\n  display: flex;\n  gap: 25px;\n  /* margin-top: 10px; */\n  margin: 10px;\n}\n.button-add-row button {\n  background-color: rgb(132, 199, 174);\n  color: white;\n  height: 26px;\n  padding: 3px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: none;\n  font-size: 9px;\n  width: 65px;\n}\n/* forms section css */\n\n.form-section-add-leave {\n  /* border: 1px solid black; */\n  height: auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n.heading-add button {\n  all: unset;\n  color: white;\n  background-color: #75b39d;\n  width: 80px;\n  height: 28px;\n  text-align: center;\n  border-radius: 4px;\n}\n.container-name-section {\n  display: flex;\n  flex-direction: row;\n  gap: 7%;\n}\n.name-section input {\n  all: unset;\n  border: 1px solid #b6b6b6;\n  border-radius: 4px;\n  padding: 5px;\n  margin-top: 2px;\n  font-size: 0.8rem;\n  padding: 8px;\n  margin-top: 4px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  /* width: 40%; */\n}\n.name-section input::placeholder {\n  font-size: 10px;\n  opacity: 50%;\n  padding-left: 0px;\n}\n.name-section {\n  margin: 7px;\n}\n.name-section label {\n  all: unset;\n  display: flex;\n  flex-direction: column;\n  font-size: 0.8rem;\n  color: rgb(33, 33, 33);\n}\n\n.heading-add {\n  height: 50px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.lable-add-section {\n  border-bottom: 1px solid gray;\n  margin: 5px;\n  display: flex;\n  /* border: 1px solid black; */\n  /* width: 22%; */\n  /* justify-content: space-around; */\n  gap: 2px;\n}\n.lable-add-section label {\n  /* all: unset; */\n  border-right: 1px dotted black;\n  padding: 6px;\n  font-size: 13px;\n  width: 90px;\n  text-align: center;\n  /* color: rgb(33, 33, 33); */\n}\n.lable-add-section label:hover {\n  cursor: pointer;\n}\n\n.criteria-input-section {\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n}\n.criteria-input-section label {\n  all: unset;\n  font-size: 0.8rem;\n  margin-bottom: -5px;\n  color: rgb(33, 33, 33);\n  margin-bottom: 2px;\n}\n.criteria-input-section select {\n  border: 1px solid #b6b6b6;\n  /* width: 14%; */\n  border-radius: 3px;\n  padding: 6px;\n  margin-top: 6px;\n  color: rgb(59, 59, 59);\n  font-size: 12px;\n}\n.leave-credit-on {\n  display: flex;\n  justify-content: start;\n}\n.credit-button-section {\n  margin-left: 1%;\n  height: auto;\n  /* border: 1px solid black; */\n}\n.credit-button-container {\n  display: flex;\n  gap: 26%;\n  /* border: 1px solid black; */\n  margin-top: 10px;\n}\n.credit select {\n  font-size: 12px;\n  border: 1px solid #b6b6b6;\n  width: 14%;\n  padding: 3px;\n  border-radius: 3px;\n  margin-left: -1px;\n  color: #585858;\n}\n.credit {\n  margin-left: -1px;\n}\n.container-new-joinee {\n  display: flex;\n  gap: 5px;\n}\n.container-new-joinee label {\n  font-size: 0.8rem;\n  color: rgb(33, 33, 33);\n  margin-bottom: 0px;\n}\n#new-joinee {\n  width: 13px;\n}\n.leave-credit-on {\n  /* display: flex; */\n  gap: 10px;\n  margin-top: 12px;\n  /* border: 1px solid black; */\n}\n.leave-credit-input {\n  width: 12px;\n}\n.leave-credit-on label {\n  font-size: 13px;\n  margin-bottom: 0px;\n  color: rgb(33, 33, 33);\n  width: 100%;\n}\n\n.main-container-leve-no-days {\n  display: flex;\n  gap: 16.8%;\n  margin-bottom: 15px;\n  margin-top: 18px;\n}\n\n.no-of-days input[type=\"text\"] {\n  all: unset;\n  border: 1px solid #b6b6b6;\n  width: 49%;\n  border-radius: 4px;\n  padding: 4px;\n}\n.no-of-days input[type=\"text\"]::placeholder {\n  font-size: 11px;\n  color: #a2a2a2;\n}\n.no-of-days label {\n  font-size: 0.8rem;\n  color: rgb(33, 33, 33);\n  margin-bottom: 5px;\n}\n/* table leveas */\n\n.table-wrapper {\n  border-radius: 8px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border: 1px solid #d9e3d9;\n  background-color: white;\n  height: 380px;\n}\n.table-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.table-row,\n.table-header-leaves {\n  display: grid;\n  grid-template-columns: 1fr 2fr 2fr 2fr 2fr 2fr 1fr;\n  padding: 7px;\n  height: 31px;\n  font-size: 0.7rem;\n  text-align: center;\n}\n\n.table-header-leaves {\n  background-color: #d8f3d8;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.table-row button {\n  font-size: 0.7rem;\n}\n.input-container-form {\n  box-sizing: border-box;\n  /* border: 1px solid black; */\n}\n.leaves-action-buttons {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  gap: 5px;\n}\n\n/* new joinee table */\n.table-header-sections {\n  display: grid;\n  grid-template-columns: 2fr 2fr 2fr 2fr;\n  padding: 4px;\n  height: 20px;\n  font-size: 0.7rem;\n  text-align: center;\n  background-color: #d8f3d8;\n  width: 100%;\n  /* margin: 0px; */\n  font-weight: 600;\n  border-radius: 4px;\n}\n\n/* Encshment css */\n.encashment-button-section {\n  /* border: 1px solid black; */\n  height: auto;\n  width: 100%;\n  display: flex;\n  gap: 10%;\n}\n.checked-section {\n  /* border: 1px solid black; */\n\n  height: auto;\n  width: 15%;\n}\n.encash-input-section {\n  /* border: 1px solid black; */\n\n  height: auto;\n\n  width: 30%;\n}\n\n/* Applicability */\n\n.criteria-table-sections {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding: 4px;\n  height: 20px;\n  font-size: 0.7rem;\n  text-align: center;\n  background-color: #d8f3d8;\n  width: 100%;\n  margin-top: 5px;\n  font-weight: 600;\n}\n\n.criteria-row {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  gap: 18%;\n  font-size: 0.7rem;\n  /* margin-top: 6px; */\n  border-bottom: 1px solid rgb(170, 170, 170);\n  margin: 5px 0px 9px;\n}\n\n.view-icon {\n  color: #84c7ae;\n  height: 18px;\n  width: 15px;\n}\n.back-icon {\n  /* margin-top: 10px; */\n  height: 12px;\n}\n\n.criteria-input-section option {\n  font-size: 12px;\n  color: rgb(66, 66, 66);\n}\n\n.container-table {\n  border: 1px solid rgb(119, 119, 119);\n  margin-top: 8px;\n  border-radius: 4px;\n  width: 45%;\n}\n\n.activeclass {\n  color: white;\n  background-color: rgb(132, 199, 174);\n}\n.non-active {\n  color: black;\n}\n.save-button-div {\n  width: 20%;\n  height: 40px;\n\n  margin: 20px 0px 0px 10px;\n}\n\n.leave-view-edit-delete {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.leave-credit-on {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  margin-top: 50px;\n}\n\n.tooltip-label {\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.tooltip-text {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  bottom: 125%; /* adjust as needed */\n  left: 0;\n  width: 240px;\n  background-color: #444;\n  color: #fff;\n  padding: 8px;\n  border-radius: 6px;\n  z-index: 10;\n  transition: opacity 0.3s;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);\n}\n\n.tooltip-text::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 10px;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #444 transparent transparent transparent;\n}\n\n.tooltip-label:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n}\n.attendance-percentage-section input {\n  width: 63%;\n}\n\n/* Default: Mobile-first styles (below 768px) */\n/* Keep your base styles here */\n\n/* Tablets: 768px to 1024px */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .define-leave-main,\n  .form-section-add-leave,\n  .input-container-form {\n    width: 100%;\n    height: auto;\n    box-sizing: border-box;\n  }\n\n  .heading-add {\n    height: 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .heading-add button {\n    all: unset;\n    color: white;\n    background-color: #75b39d;\n    width: 80px;\n    height: 24px;\n    text-align: center;\n    border-radius: 4px;\n  }\n\n  .container-name-section {\n    display: flex;\n    flex-direction: row;\n    gap: 7%;\n  }\n\n  .name-section {\n    margin: 7px;\n  }\n\n  .name-section label {\n    all: unset;\n    display: flex;\n    flex-direction: column;\n    font-size: 0.8rem;\n    color: #212121;\n  }\n\n  .name-section input {\n    all: unset;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 8px;\n    margin-top: 4px;\n    font-size: 0.8rem;\n  }\n\n  .lable-add-section {\n    display: flex;\n    border-bottom: 1px solid gray;\n    margin: 5px;\n    gap: 2px;\n  }\n\n  .lable-add-section label {\n    border-right: 1px dotted black;\n    padding: 6px;\n    font-size: 13px;\n    width: 90px;\n    text-align: center;\n  }\n\n  .credit-button-section {\n    margin-left: 1%;\n  }\n\n  .credit-button-container {\n    display: flex;\n    gap: 26%;\n    margin-top: 10px;\n  }\n\n  .criteria-input-section {\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n  }\n\n  .main-container-leve-no-days {\n    display: flex;\n    gap: 16.8%;\n    margin: 18px 0 15px;\n  }\n\n  .leave-credit-on {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 30px;\n  }\n\n  .no-of-days {\n    margin-left: -4px;\n  }\n  .encashment-button-section {\n    /* border: 1px solid black; */\n    height: auto;\n    width: 100%;\n    display: flex;\n    gap: 10%;\n  }\n  .checked-section {\n    /* border: 1px solid black; */\n    height: auto;\n    width: 23%;\n  }\n}\n\n/* 768px exact fix (e.g., some edge cases on tablets) */\n@media screen and (width: 768px) {\n  .no-of-days {\n    margin-left: -32px;\n  }\n}\n\n/* Small Desktops: 1025px to 1439px */\n@media screen and (min-width: 1025px) and (max-width: 1440px) {\n  /* You can inherit most styles from tablet if they work fine */\n  /* Only override differences here */\n  .leave-credit-on {\n    margin-top: 15px;\n  }\n  .credit-button-container {\n    gap: 30%;\n  }\n\n  .main-container-leve-no-days {\n    gap: 18%;\n  }\n\n  .no-of-days {\n    margin-left: 35px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
